<template>
    <div>
        <vs-popup class="holamundo" icon-close="X" :title="this.title" :active.sync="active">
            <div class="content">
                <section class="section--sidebar-user">
                    <section class="section--content-sidebar section--content-sidebar-full-height">
                        <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data"  class="workflow-tabs">
                            <div class="tab-content">
                                <input type="hidden" name="_token" :value="csrf">
                                <input v-if="this.editing" type="hidden" name="_method" value="PUT">
                                
                                
                                <div class="row mb-3">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.title")}}</label>
                                            <input
                                            type="text"
                                            class="form-control rounded"
                                            name="questionBase[name]"
                                            :value="name"
                                            />
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.description")}}</label>
                                            <input type="text" class="form-control rounded" name="questionBase[description]" :value="description">
                                        </div>
                                        
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Question.sorting")}}</label>
                                            <input type="number" class="form-control rounded" name="questionBase[sorting]" :value="sorting">
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row">
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{ __("forms.Evaluation.session") }}</label>
                                            <select class="form-control rounded" name="questionSettings[evaluation_session_id]" v-model="sessionId" required >
                                                <option v-for="(session) in sessionList" :value="session.id" :key="session.id">{{ session.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>{{__("forms.Workflows.survey")}}</label>
                                            <select required class="form-control rounded" name="questionSettings[survey_id]" v-model="surveyId" @change="loadQuestionSurvey()">
                                                <option v-for="(survey) in surveyList" :value="survey.id" :key="survey.id">{{ survey.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-12 col-md-4">
                                        <div class="form-group">
                                            <label>Question from external survey</label>
                                            <select required class="form-control rounded" name="questionSettings[question_survey_id]" v-model="questionSurveyId">
                                                <option v-for="(question) in surveyQuestions" :value="question.id" :key="question.id">{{ question.name }}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                
                  

                                <div class="row">
                                    <div class="col-12">
                                        <label>{{ __("forms.EvaluationChart.evaluationType") }}</label>
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-control custom-switch">
                                            <input  type="checkbox" class="custom-control-input"  id="self" value="self" v-model="evaluationTypes" name="questionSettings[evaluation_types][]">
                                            <label class="custom-control-label" for="self">
                                                Self Evaluation
                                            </label>
                                        </div> 
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-control custom-switch">
                                            <input  type="checkbox" class="custom-control-input" id="top_down" value="top_down" v-model="evaluationTypes" name="questionSettings[evaluation_types][]">
                                            <label class="custom-control-label" for="top_down">
                                                Top down
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-control custom-switch">
                                            <input  type="checkbox" class="custom-control-input" id="peer" value="peer" v-model="evaluationTypes" name="questionSettings[evaluation_types][]">
                                            <label class="custom-control-label" for="peer">
                                                Peer
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-3">
                                        <div class="custom-control custom-switch">
                                            <input  type="checkbox" class="custom-control-input" id="bottom_up" value="bottom_up" v-model="evaluationTypes" name="questionSettings[evaluation_types][]">
                                            <label class="custom-control-label" for="bottom_up">
                                                Bottom up
                                            </label>
                                        </div>
                                    </div>
                                </div>
                                
                                
                                
                                
                                
                                <div class="form-group">
                                    <label class="mb-3">{{ __("views.Modules.settings") }}</label>
                                    <div v-if="(questionSurveyId !== undefined) && (surveyQuestions[questionSurveyId] !== undefined) && surveyQuestions[questionSurveyId].question_id === 8 ">
                                        <div class="form-group">

                                            <label>{{ __("forms.EvaluationChart.questions.questions_setting.question18.pnp_summary_column") }}</label>
                                            <select v-model="pnpSummaryColumn" name="questionSettings[pnp_summary_column]" class="form-control">
                                                <option v-for="column in columnsPnp" :value="column">
                                                    {{column}}
                                                </option>
                                            </select>
                                        </div>
                                        <div class="form-group">
                                          <input type="checkbox"  v-model="showAllPnpColumns" value="1"  name="questionSettings[show_all_pnp_columns]">
                                            <label>{{ __("forms.EvaluationChart.questions.questions_setting.question18.show_all_pnp_columns") }}</label>
                                        </div>
<!--                                        <label>PNP Summary Value</label>-->
                                        <div class="form-group">
<!--                                            <label for="p_n_p_values">Average</label>-->
<!--                                            <select id="p_n_p_values" v-model="summaryFieldConfig['show_values']" name="questionSettings[summary_field_config][show_values]" class="form-control">-->
<!--                                                <option value="avg">Average</option>-->
<!--                                            </select>-->
                                          <input type="hidden" v-model="summaryFieldConfig['show_values']" name="questionSettings[summary_field_config][show_values]" >
<!--                                          {{ summaryFieldConfig['show_values'] }}-->
                                        </div>


                                        <hr>
                                        <label>
                                          {{ __("forms.EvaluationChart.questions.questions_setting.question18.show_column_of_evalutions") }}
                                        </label>
                                        <div class="form-group">
                                            <input type="checkbox"  value="self" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                            <label for="self">Self Evaluation</label>
                                            <input type="checkbox" value="top_down" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                            <label for="top_down">Top Down</label>
                                            <input type="checkbox" value="peer" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                            <label for="peer">Peer</label>
                                            <input type="checkbox"  value="bottom_up" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                            <label for="bottom_up">Bottom Up</label>
                                            <input type="checkbox" value="total" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                            <label for="total">
                                              {{ __("forms.EvaluationChart.questions.questions_setting.question18.total") }}
                                            </label>
                                        </div>
                                    </div>
                                    <div v-else-if="(questionSurveyId !== undefined)  && (surveyQuestions[questionSurveyId] !== undefined)  && surveyQuestions[questionSurveyId].question_id === 1 ">
                                        <div class="row">
                                            <div class="col-12">
                                                <label>{{ __("forms.EvaluationChart.questions.questions_setting.question18.show_values_of_evalutions") }}</label>
                                            </div>
                                        </div>
                                        <div class="row mb-3">
                                            <div class="col-12 col-md-3">
                                                <div class="custom-control custom-switch">
                                                    <input  type="checkbox" class="custom-control-input" id="show_self" value="self" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                                    <label class="custom-control-label" for="show_self">
                                                        Self Evaluation
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="custom-control custom-switch">
                                                    <input  type="checkbox" class="custom-control-input" id="show_top_down" value="top_down" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                                    <label class="custom-control-label" for="show_top_down">
                                                        Top down
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="custom-control custom-switch">
                                                    <input  type="checkbox" class="custom-control-input" id="show_peer" value="peer" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                                    <label class="custom-control-label" for="show_peer">
                                                        Peer
                                                    </label>
                                                </div>
                                            </div>
                                            <div class="col-12 col-md-3">
                                                <div class="custom-control custom-switch">
                                                    <input  type="checkbox" class="custom-control-input" id="show_bottom_up" value="bottom_up" v-model="summaryFieldConfig['show_type_evaluation']" name="questionSettings[summary_field_config][show_type_evaluation][]">
                                                    <label class="custom-control-label" for="show_bottom_up">
                                                        Bottom up
                                                    </label>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mb-3">
                                            <div class="col-12">
                                              <label>{{ __("forms.EvaluationChart.questions.questions_setting.question18.show_name_of_compiler") }}</label>
                                            </div>
                                            <div class="col-12">
                                                <div class="custom-control custom-switch">
                                                    <input  type="checkbox" class="custom-control-input" id="show_name" value="1" v-model="summaryFieldConfig['show_compiler']" name="questionSettings[summary_field_config][show_compiler]">
                                                    <label class="custom-control-label" for="show_name">
                                                       {{__("misc.yes")}}
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                      
                                    </div>
                                    <div v-else>
                                        This question isn't ready for a summary
                                    </div>
                                    
                                </div>
                                
                                
                                <div class="row">
                                    <div class="col-12">
                                        <hr>
                                    </div>
                                    <div class="col-12 mt-3 text-right" v-if="can_write">
                                        <button class="btn btn-next" type="submit">{{ __('misc.save') }}</button>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </section>
                </section>
            </div>
        </vs-popup>
    </div>
</template>

<script>
export default {
    
    mounted() {
        
    },
    props: {
        can_write:{
            type:Boolean,
            required:true,
        }
    },
    data () {
        return {
            
            surveyId : 0,
            questionSurveyId : 0,
            sessionId : 0,
            
            surveyList: [],
            sessionList: [],
            evaluationTypes : [],
            showAllPnpColumns : false,
            surveyQuestions : {
                0 : {question_id : 0}
            },
            pnpSummaryColumn : null,
            columnsPnp : [],
            summaryFieldConfig : [],
            //default
            title: "Summary",
            active : false,
            action : "",
            name:"",
            description:"",
            sorting:-1,
            editing : true,
            csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        }
    },
    methods: {
        
        loadPnpColumns(){
            
            if(this.questionSurveyId === null){
                return;
            }
            
            axios.get("/api/questions-survey-get-pnp-columns/"+this.questionSurveyId+"/question-survey")
            .then((response) => {
                
                this.columnsPnp = response.data;
                console.log("COLUMNS "+this.columnsPnp);
                
            }).catch(function(error){
                alert(error);
            });
        },
        loadQuestionSurvey(){
            
            if(this.surveyId === undefined || this.surveyId === null){
                return;
            }
            
            axios.get("/api/questions-survey-get-question/"+this.surveyId+"/survey")
            .then((response) => {
                this.surveyQuestions = response.data;
                
            }).catch(function(error){
                alert(error);
            });
        },
        
        toggle(action, item_id, editing, attributes) {
            this.active     = true;
            this.action     = action;
            this.editing    = editing;
            
            let dataRoute   = decodeURI(attributes.dataRoute);
            if (dataRoute!==undefined) {
                if (dataRoute.indexOf("[id]")>0) {
                    dataRoute = dataRoute.replace("[id]", item_id);
                    
                }
                axios.get(dataRoute)
                .then((response) => {
                    this.name = response.data.base.name;
                    this.description = response.data.base.description;
                    this.sorting = response.data.base.sorting;
                    this.surveyList = response.data.surveys;
                    this.sessionList = response.data.sessions;
                    this.surveyId = response.data.survey_id;
                    this.sessionId = response.data.evaluation_session_id;
                    this.questionSurveyId = response.data.question_survey_id;
                    this.pnpSummaryColumn = response.data.pnp_summary_column;
                    this.showAllPnpColumns = response.data.show_all_pnp_columns;
                    this.evaluationTypes = response.data.evaluation_types;
                    this.summaryFieldConfig = response.data.summary_field_config;
                    console.log(response.data.summary_field_config);
                    this.loadQuestionSurvey();
                    this.loadPnpColumns();
                    this.can_write = app.__vue__.questionPermission(this.can_write,response.data.base.enable);           
                });
            }
        }
        
    }
    
}
</script>
